<template>
  <div class="navbarnav">
    <div
      class="overwrapper"
      :class="{'open':navbar.navActive === 'isNavbar'}"
      @click="toggle('isNavbar')"
    ></div>
    <div
      class="overwrapperavatar"
      :class="{'open':navbar.navActive === 'isAvatar'}"
      @click="toggle('isAvatar')"
    ></div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="d-flex align-items-center justify-content-around">
            <div class="d-flex align-items-center ml-auto">
              <m-logo/>
              <m-categories/>
              <m-navbar :items="navbar.listNavbar"/>
            </div>
            <div
              class="d-flex align-items-center"
              :class="{'w-25':windowWidth > 1200 , 'w-50':windowWidth < 1200 ,  'w-75':windowWidth < 768}"
            >
              <!--justify-content-around-->
              <div
                class="d-flex align-items-center w-100"
                :class="{'justify-content-end':!isLogin,'justify-content-around':isLogin}"
              >
                <m-basket-shopping v-if="isLogin"/>
                <m-quick-access/>
                <!-- <m-search :class="{'ml-2':!isLogin}"/> -->
                <m-avatar/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MCategories from '~ui/categories'
import MSearch from '~ui/search'
import MBasketShopping from '~ui/basket/basket.vue'
import MNavbar from '~ui/navbar/navbar.vue'
import MLogo from '~ui/logo'
import MQuickAccess from '~ui/quick-access'
import MAvatar from '~ui/avatar'

export default {
  name: 'navbar',
  components: {

    MCategories,
    MQuickAccess,
    MSearch,
    MBasketShopping,
    MNavbar,
    MLogo,
    MAvatar
  },
  provide() {
    let data = {};
    this.$observer(data, ["navbar", "isLogin", "isInstructor", "isPatch"]);
    return {
      data,
      methods: {
        toggle: this.toggle,
        logOut: this.logOut
      }
    }
  },
  computed: {
    windowWidth() {
      return this.$store.state.layout.windowWidth
    },
    navbar() {
      return this.$store.state.navbar
    },
    isLogin() {
      return this.$store.state.auth.isLogin
    },
    isPatch() {
      return !!(this.$route.path == '/dashboard/new-course')
    }
  },
  watch: {
    async isLogin(val) {
      this.isInstructor = await this.checkAccess(false)
    }
  },
  data() {
    return {
      isInstructor: false
    }
  },
  async mounted() {
    this.isInstructor = await this.checkAccess(false)
  },
  methods: {
    toggle(param) {
      if (param !== '' && this.navbar.navActive === param) {
        this.$store.commit('navbar/SET_DATA', { data: '', id: 'navActive' })
        return
      }
      this.$store.commit('navbar/SET_DATA', { data: param, id: 'navActive' })
    },
    logOut() {
      this.$store.dispatch('auth/logOut')
      this.toggle('isAvatar')
    }
  }
}
</script>

<style lang="less">
@import (reference) "../assets/css/variable.less";
.navbarnav {
  display: block;
  height: 60px;
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 888;
  transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
}
.overwrapper {
  position: fixed;
  background: rgba(53, 63, 70, 0.5);
  right: -1000px;
  left: 0;
  bottom: 0;
  top: 0;
  visibility: hidden;
  opacity: 0.1;
  transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  -webkit-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  -moz-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  -ms-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  -o-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  z-index: 6;
}

.overwrapperavatar {
  position: fixed;
  right: -1000px;
  left: 0;
  bottom: 0;
  top: 0;
  visibility: hidden;
  opacity: 0.1;
  z-index: 4;
  transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  -webkit-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  -moz-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  -ms-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  -o-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
}

.overwrapper.open,
.overwrapperavatar.open {
  right: 0;
  visibility: visible;
  opacity: 0.5;
}
.backtoTop {
  background: #fff;
  color: #000;
  border: none;
  border-radius: 50%;
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 40px;
  height: 40px;
  z-index: 9999999999;
  -webkit-box-shadow: 0px 4px 6px 0px rgba(204, 204, 204, 0.2);
  -moz-box-shadow: 0px 4px 6px 0px rgba(204, 204, 204, 0.2);
  box-shadow: 0px 4px 6px 0px rgba(204, 204, 204, 0.2);
}
///////////

@media screen and (max-width: 992px) {
  .navbarnav {
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue